import React, { useEffect, useState, useCallback } from "react";
import MyNotificationsContent from "../Components/MyNotifactions/index";
import NotificationPermissionBanner from "../Components/NotificationPermissionBanner";
import axios from "../axiosConfig";
import { useNotifications } from "../Context/NotificationsContext";

const MyNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { refresh } = useNotifications();

  useEffect(() => {
    setIsLoading(true);
    const getNotificationsData = async () => {
      try {
        const data = await axios.get("/user/notifications");
        setNotifications(data);
        setIsLoading(false);
      } catch (e) {
        console.log("e", e);
      }
    };
    getNotificationsData();
  }, []);

  const markAsRead = useCallback(async (notificationId) => {
    try {
      await axios.post("/user/notifications/read", { notificationId });
      setNotifications(prev => 
        prev.map(n => n.id === notificationId ? { ...n, isRead: true } : n)
      );
      refresh();
    } catch (e) {
      console.log("Error marking notification as read:", e);
    }
  }, [refresh]);

  const markAllAsRead = useCallback(async () => {
    try {
      await axios.post("/user/notifications/read-all");
      setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));
      refresh();
    } catch (e) {
      console.log("Error marking all notifications as read:", e);
    }
  }, [refresh]);

  const unreadCount = notifications.filter(n => !n.isRead).length;

  return (
    <>
    <NotificationPermissionBanner />
    <MyNotificationsContent
      notifications={notifications}
      isLoading={isLoading}
      markAsRead={markAsRead}
      markAllAsRead={markAllAsRead}
      unreadCount={unreadCount}
    />
    </>
  );
};

export default MyNotifications;
